const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Immigration extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Immigration,
            "All civilizations with the most happy faces gain 1 population.",
            {}
        )
    }
}

module.exports = Immigration;